import "./Products.module.css";
import Header from "@/reusable_sections/Header";
import ProductGrid from "./sections/ProductGrid";
import Footer from "@/reusable_sections/Footer";
export default function ProductsPage() {
  return <div>
      <Header />
      <ProductGrid />
      <Footer />
    </div>;
}